import withLocationOptions from '../withLocationOptions/withLocationsOptions';
import LocationSelectByNpi from './locationSelectByNpi';

export default withLocationOptions(LocationSelectByNpi);
